export default __webpack_public_path__ + "static/media/VlaanderenLogo.b57dc5f9.jpg";